import { Statistic } from "antd";
import React, { createContext, useContext } from "react";
import { Observer } from "mobx-react-lite";

import FlowstationPerformanceStore from "../store/FlowstationPerformanceStore";

import { ProgressIndicator } from "@fluentui/react";
const flowstationPerformanceStoreCtx = createContext(
  FlowstationPerformanceStore
);
export const TotalBoeCard = () => {
  const flowstationPerformanceStore = useContext(
    flowstationPerformanceStoreCtx
  );

  return (
    <div className="ms-Grid " dir="ltr">
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Observer>
            {() =>
              flowstationPerformanceStore.isLoading ? (
                <div style={{ paddingTop: "25px" }}>
                  <ProgressIndicator
                    label="Loading  total boe dashlet,please wait..."
                    description=""
                  />
                </div>
              ) : (
                <Statistic
                  title={
                    <div style={{ fontSize: "20px", paddingTop: "10px" }}>
                      Total BOE
                    </div>
                  }
                  value={Number(
                    flowstationPerformanceStore.totalBoe
                  ).toLocaleString()}
                  suffix={
                    <span style={{ fontSize: "16px", fontFamily: "consolas" }}>
                      BOEPD
                    </span>
                  }
                  valueStyle={{
                    fontSize: "30px",
                    color: "darkblue",
                    fontFamily: "consolas",
                  }}
                  prefix={
                    <div
                      style={{ fontSize: "12px", color: "gray" }}
                    >{`@${flowstationPerformanceStore.selMonthName},${flowstationPerformanceStore.selYear}`}</div>
                  }
                />
              )
            }
          </Observer>
        </div>
      </div>
    </div>
  );
};

